import { Injectable } from '@angular/core';
import { navigationSetHasSave } from './navigation-state/navigation-state.actions';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(private store: Store) {}

  private savePage$ = new Subject();
  private saveResult$ = new Subject<boolean>();
  private saveState$ = new BehaviorSubject(null);

  get watchPage() {
    return this.savePage$;
  }

  set saveState(state: boolean | null) {
    this.saveState$.next(state);
  }
  get watchSaveState() {
    return this.saveState$;
  }

  private _saveButton;
  set saveButton(button: HTMLElement) {
    console.log('SETTING SAVE BUTTON TO', button);
    this._saveButton = button;
  }
  get saveButton() {
    return this._saveButton;
  }
  hasSaveButton(hasSave: boolean) {
    this.store.dispatch(navigationSetHasSave({ hasSave }));
  }
  setSaveResult(result: boolean) {
    this.saveResult$.next(result);
  }

  savePage() {
    this.savePage$.next(true);
    return this.saveResult$;
  }
}
